import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  image,
  url,
  type = 'website',
  keywords = [],
  schema
}) => {
  const siteName = 'Privacy Fotos';
  const defaultDescription = 'Encontre os melhores criadores da Privacy com avaliações reais de assinantes.';
  const defaultImage = 'https://privacyfotos.com.br/og-image.png';
  const baseUrl = 'https://privacyfotos.com.br';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Avaliações de Criadores de Conteúdo`;
  const fullDescription = description || defaultDescription;
  const fullImage = image || defaultImage;
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const fullKeywords = ['privacy fotos', 'privacy plataforma', 'criadores privacy', ...keywords].join(', ');

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
